import HC from "@/lib/compute";
import { f2, fint, bandM, BAND_COLOR } from "@/lib/ui";
import { Chip } from "@/components/dash/Bits";

export function HeroCard({ o, f }) {
  const ps = o.proj.score, summed = o.proj.sumsAcross, b = summed ? null : bandM(ps);
  const withData = o.profile.filter(r => r.v !== null), wCov = withData.reduce((a, r) => a + (r.w || 0), 0);
  const heroLabel = f.p ? "Project score" : summed ? `Project Score · sum of ${o.nProjects} projects` : `Average project score · ${o.nProjects} projects`;
  return (
    <div className="card span-5 hero-card" data-testid="hero-card">
      <div className="kpi-label">{heroLabel}</div>
      <div className="hero" style={{ marginTop: "8px" }}>
        <div className="hero-num" style={{ color: b ? BAND_COLOR[b] : "var(--ink-3)" }} data-testid="hero-score">{f2(ps)}{summed ? null : <small>/ 5</small>}</div>
        <div className="hero-side">{summed ? null : <div><Chip b={b} /></div>}</div>
      </div>
      {summed ? <div className="hnote warn">This is the <b>sum</b> of all {o.nProjects} projects' scores, as Power BI shows it, so it is not on the 1–5 scale. Pick one project to see its score out of 5.</div> : null}
      {f.p && o.profile.length ? <>
        <div className="cov" aria-hidden="true">{o.profile.map(r => <i key={r.ind} className={r.v !== null ? "on" : ""} title={r.ind}></i>)}</div>
        <div className="hnote" data-testid="coverage-note">{withData.length === o.profile.length ? `All ${o.profile.length} indicators have data.` : <><b>{withData.length} of {o.profile.length} indicators</b> have data ({Math.round(wCov * 100)}% of the weight). Power BI adds the weighted indicator scores without rescaling, so indicators with no data pull this score down.</>}</div>
      </> : null}
    </div>
  );
}

export function RespCard({ o, f }) {
  const noScope = !f.p && !f.fy && !f.rid;
  const P = new Set(f.p ? [f.p] : HC.projectsFor(f.fy, f.rid));
  const inScope = p => noScope || P.has(p);
  const subsSel = (HC.M.data.status || []).filter(s => inScope(s.p));
  const subApproved = subsSel.reduce((a, s) => a + s.approved, 0), subPending = subsSel.reduce((a, s) => a + s.pending, 0);
  const RC = HC.M.data.rc || null;
  const rcSel = RC ? Object.keys(RC).filter(inScope).reduce((acc, p) => acc + Object.entries(RC[p] || {}).filter(([t]) => !f.tool || t === f.tool).reduce((x, [, n]) => x + n, 0), 0) : null;
  return (
    <div className="card span-3"><div className="kpi-label">Response Count</div><div className="kpi-big" data-testid="response-count">{rcSel === null ? "—" : fint(rcSel)}</div>
      <div className="kpi-cap">SurveyCTO forms filled</div>
      <dl className="facts"><dt>Answers scored</dt><dd data-testid="answers-scored">{fint(o.totalResp)}</dd>{subsSel.length ? <><dt>Approved</dt><dd>{fint(subApproved)}</dd><dt>Pending review</dt><dd>{fint(subPending)}</dd></> : null}<dt>Tools</dt><dd>{o.tools.join(", ") || "—"}</dd></dl></div>
  );
}

export function MetaCard({ o, f }) {
  if (f.p) {
    const ip = HC.M.ipBy[f.p] || {};
    return (
      <div className="card span-4"><div className="kpi-label">Project</div><div className="kpi-big" style={{ fontSize: "30px" }} data-testid="selection-title">{f.p}</div>
        <dl className="kv"><dt>Partner</dt><dd>{ip.partner || "—"}</dd><dt>State</dt><dd>{(ip.state || "—").trim()}</dd><dt>Type</dt><dd>{ip.type || "—"}</dd><dt>Agency</dt><dd className="num" style={{ fontSize: "12px" }}>{ip.rid || "—"}</dd><dt>Year</dt><dd>{ip.fy || "—"}</dd></dl></div>
    );
  }
  return (
    <div className="card span-4"><div className="kpi-label">Selection</div><div className="kpi-big" style={{ fontSize: "30px" }} data-testid="selection-title">{o.nProjects} projects</div>
      <dl className="kv"><dt>Agency</dt><dd className="num" style={{ fontSize: "12px" }}>{f.rid || "All agencies"}</dd><dt>Year</dt><dd>{f.fy || "All years"}</dd><dt>Scored</dt><dd className="num">{o.projRows.filter(r => r.pbi !== null).length}</dd></dl>
      <p className="sub" style={{ marginTop: "10px" }}>Pick a project to see its full breakdown.</p></div>
  );
}
